// https://codesandbox.io/s/kspqr?file=/demo.js

import React from "react";
import { Field, ErrorMessage } from "formik";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Favorite from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";

// const startAdornment = (isDisplay) => ({
//   startAdornment: (
//     <InputAdornment position="start">
//       <PriorityHighIcon style={{ color: "red", display: isDisplay }} />
//     </InputAdornment>
//   ),
// });

function CheckBox(props) {
  const [selectedCheck, setselectedCheck] = React.useState();
  const handleCheckChange = (value) => {
    setselectedCheck(value);
    console.log("Date:", value);
  };

  const {
    label,
    name,
    field,
    errorobj,
    touched,
    onChange,
    blur,
    ...rest
  } = props;
  return (
    <div>
      <Field id={name} name={name} label={label} {...rest}>
        {({
          field, // { name, value, onChange, onBlur }
          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          meta,
        }) => (
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  id={name}
                  name={name}
                  color="primary"
                  checked={selectedCheck}
                  onChange={handleCheckChange}
                  {...rest}
                  {...field}
                  //   InputProps={meta.touched && meta.error && startAdornment("block")}
                />
              }
              label={label}
            />

            {meta.touched && meta.error && (
              <div className="error">{meta.error}</div>
            )}
          </div>
        )}
      </Field>
    </div>
  );
}

export default CheckBox;
